import React from 'react';
import { Route } from 'react-router';
import { PhotoGalleryPage } from '@pages/Portal/PhotoGalleryPage';

export const portalPhotosRoutes = (
  <Route path="photos">
    <Route index element={<PhotoGalleryPage />} />
  </Route>
);
